import { Badge, Button, Modal } from '@indipia/ui-core'
import { formatMD } from '@indipia/shared'
import { ORDER_MESSAGE } from '../../constants/materialOrder.logic'

// 일괄 발송 직전 확인 창(1회). 보낼 수 있는 행과 '보낼 수 없음' 행(사유)을 나누어 보여준다. 지연·되돌리기 없음.

export interface BatchConfirmEntry {
  orderVendorId: number
  workTypeName: string
  vendorName: string
  deliveryDate: string | null
}

export interface BatchBlockedEntry extends BatchConfirmEntry {
  reasons: string[]
}

interface Props {
  open: boolean
  sendable: BatchConfirmEntry[]
  blocked: BatchBlockedEntry[]
  sending: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function OrderSendConfirmModal({ open, sendable, blocked, sending, onConfirm, onCancel }: Props) {
  return (
    <Modal
      open={open}
      onClose={() => { if (!sending) onCancel() }}
      title={ORDER_MESSAGE.batchConfirmTitle(sendable.length)}
      size="md"
      footerAlign="stretch"
      footer={<>
        <Button variant="secondary" disabled={sending} onClick={onCancel}>{ORDER_MESSAGE.cancel}</Button>
        <Button variant="primary" loading={sending} disabled={sendable.length === 0} onClick={onConfirm}>
          {ORDER_MESSAGE.batchSend}
        </Button>
      </>}
    >
      <div className="flex flex-col gap-3">
        {sendable.length > 0 && (
          <section aria-label={ORDER_MESSAGE.popup.batchSendable}>
            <div className="text-caption font-semibold text-text-muted">{ORDER_MESSAGE.popup.batchSendable}</div>
            <ul className="mt-1 flex flex-col gap-1">
              {sendable.map(e => {
                const md = formatMD(e.deliveryDate)
                return (
                  <li key={e.orderVendorId} className="flex flex-wrap items-center gap-2 text-body-sm text-text-primary">
                    <span className="font-semibold">{e.workTypeName}</span>
                    <span>{e.vendorName}</span>
                    {md && <span className="text-text-muted">{ORDER_MESSAGE.popup.batchDeliveryAt(md)}</span>}
                  </li>
                )
              })}
            </ul>
          </section>
        )}
        {blocked.length > 0 && (
          <section aria-label={ORDER_MESSAGE.batchCannotSend}>
            <div className="text-caption font-semibold text-text-muted">{ORDER_MESSAGE.batchCannotSend}</div>
            <ul className="mt-1 flex flex-col gap-1">
              {blocked.map(e => (
                <li key={e.orderVendorId} className="flex flex-wrap items-center gap-2 text-body-sm text-text-primary">
                  <Badge status="mute">{ORDER_MESSAGE.batchCannotSend}</Badge>
                  <span className="font-semibold">{e.workTypeName}</span>
                  <span>{e.vendorName}</span>
                  <span className="text-text-muted">{e.reasons.join(' · ')}</span>
                </li>
              ))}
            </ul>
          </section>
        )}
      </div>
    </Modal>
  )
}
